export default [
  { name: 'Abu Dhabi', code: 'AZ' },
  { name: 'Ajman', code: 'AJ' },
  { name: 'Dubai', code: 'DU' },
  { name: 'Fujairah', code: 'FU' },
  { name: 'Ras al-Khaimah', code: 'RK' },
  { name: 'Sharjah', code: 'SH' },
  { name: 'Umm al-Quwain', code: 'UQ' }
];
